<template>
	<div>
		<el-form ref="form" :model="form" :rules="rules" label-width="160px">
			<el-row :gutter="50">
				<el-col :span="12">
					<el-form-item label="产品名称" prop="productName">
						<el-input v-model="form.productName" placeholder="请输入产品名称"></el-input>
					</el-form-item>
					<el-form-item label="产品副标题" prop="subTitle">
						<el-input v-model="form.subTitle" placeholder="请输入产品副标题"></el-input>
					</el-form-item>
					<el-form-item label="封面图片" prop="coverImage">
						<UploaderImage v-model="form.coverImage" @change="handleChange"></UploaderImage>
					</el-form-item>
					<el-form-item label="SKU" prop="sku">
						<el-input v-model="form.sku" placeholder="请输入SKU"></el-input>
					</el-form-item>
					<el-form-item label="是否在售" prop="status">
						<el-radio-group v-model="form.status">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="语言" prop="languageId">
						<Language v-model="form.languageId"></Language>
					</el-form-item>
					<el-form-item label="站点" prop="siteId">
						<Site v-model="form.siteId"></Site>
					</el-form-item>
					<el-form-item label="网址URL" prop="url">
						<el-input v-model="form.url" placeholder="请输入网址URL"></el-input>
					</el-form-item>
					<el-form-item label="IOS链接" prop="iosUrl">
						<el-input v-model="form.iosUrl" placeholder="请输入IOS链接"></el-input>
					</el-form-item>
					<el-form-item label="安卓链接" prop="androidUrl">
						<el-input v-model="form.androidUrl" placeholder="请输入安卓链接"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="持续功率 (W)" prop="continuousPower">
						<el-input v-model="form.continuousPower" v-num placeholder="请输入持续功率"></el-input>
					</el-form-item>
					<el-form-item label="功率提升模式 (W)" prop="powerBoostMode">
						<el-input v-model="form.powerBoostMode" v-num placeholder="请输入功率提升模式"></el-input>
					</el-form-item>
					<el-form-item label="浪涌功率 (W)" prop="surgePower">
						<el-input v-model="form.surgePower" v-num placeholder="请输入浪涌功率"></el-input>
					</el-form-item>
					<el-form-item label="自耗 (W)" prop="selfConsumption">
						<el-input v-model="form.selfConsumption" v-num placeholder="请输入自耗"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="50">
				<el-col :span="12">
					<el-form-item label="产品容量 (Wh)" prop="productCapacity">
						<el-input v-model="form.productCapacity" v-num placeholder="请输入产品容量"></el-input>
					</el-form-item>
					<el-form-item label="总容量 (Wh)" prop="totalCapacity">
						<el-input v-model="form.totalCapacity" v-num placeholder="请输入总容量"></el-input>
					</el-form-item>
					<el-form-item label="放电深度" prop="depthOfDischarge">
						<el-input v-model="form.depthOfDischarge" v-num placeholder="请输入放电深度"></el-input>
					</el-form-item>
					<el-form-item label="效率 (η)" prop="efficiency">
						<el-input v-model="form.efficiency" v-num placeholder="请输入效率"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="可用容量 (Wh)" prop="usableCapacity">
						<el-input disabled v-model="form.usableCapacity" v-num placeholder="请输入可用容量"></el-input>
					</el-form-item>
					<el-form-item label="电池最大数量" prop="maxBatteries">
						<el-input-number :min="0" :max="4" v-model="form.maxBatteries"
							placeholder="请输入电池最大数量"></el-input-number>
					</el-form-item>
					<el-form-item label="AC输入功率 (W)" prop="acInputPower">
						<el-input v-model="form.acInputPower" v-num placeholder="请输入AC输入功率"></el-input>
					</el-form-item>
					<el-form-item label="车充输入功率 (W)" prop="carChargerInputPower">
						<el-input v-model="form.carChargerInputPower" v-num placeholder="请输入车充输入功率"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-form-item>
				<el-button @click="$router.back()">取消</el-button>
				<el-button type="primary" @click="handleSave">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import { add, edit, detail } from "@/api/product";
import { list } from "@/api/site";
import Language from "@/components/Language";
import Site from "@/components/site";
import UploaderImage from "@/components/UploaderImage";
export default {
	components: { Language, UploaderImage,Site },
	data() {
		return {
			id: null,
			form: {
				productName: "",
				subTitle: "",
				coverImage: "",
				sku: "",
				status: 1,
				languageId: null,
				url: "",
				androidUrl: "",
				iosUrl: "",
				continuousPower: "",
				powerBoostMode: "",
				surgePower: "",
				siteId:"",
				selfConsumption: "",
				productCapacity: "",
				totalCapacity: "",
				depthOfDischarge: "",
				usableCapacity: "",
				maxBatteries: undefined,
				acInputPower: "",
				carChargerInputPower: "",
				efficiency: ""
			},
			rules: {
				productName: [{ required: true, message: "请输入产品名称" }],
				subTitle: [{ required: true, message: "请输入产品副标题" }],
				coverImage: [{ required: true, message: "请上传封面图片" }],
				sku: [{ required: true, message: "请输入SKU" }],
				status: [{ required: true, message: "请选择是否在售" }],
				languageId: [{ required: true, message: "请选择语言" }],
				siteId: [{ required: true, message: "请选择站点" }],
				url: [{ required: true, message: "请输入网址URL" }],
				androidUrl: [{ required: true, message: "请输入安卓链接" }],
				iosUrl: [{ required: true, message: "请输入IOS链接" }],
				continuousPower: [{ required: true, message: "请输入持续功率" }],
				powerBoostMode: [{ required: true, message: "请输入功率提升模式" }],
				surgePower: [{
					required: true,
					message: "请输入浪涌功率",
				}],
				selfConsumption: [{
					required: true,
					message: "请输入自耗",
				}],
				productCapacity: [{
					required: true,
					message: "请输入产品容量",
				}],
				depthOfDischarge: [{
					required: true,
					message: "请输入放电深度",
				}],
				usableCapacity: [{
					required: true,
					message: "请输入可用容量",
				}],
				maxBatteries: [{
					required: true,
					message: "请输入电池最大数量",
				}],
				acInputPower: [{ required: true, message: "请输入AC输入功率" }],
				carChargerInputPower: [{
					required: true,
					message: "请输入车充输入功率",
				}],
				efficiency: [{ required: true, message: "请输入效率" }],
			},
			tableData:[]
		}
	},
	computed: {
		calc() {
			if (!this.form.productCapacity || !this.form.depthOfDischarge || !this.form.efficiency) return "";
			return (this.form.productCapacity * this.form.depthOfDischarge * this.form.efficiency).toFixed(2);
		}
	},
	watch: {
		calc(val) {
			this.form.usableCapacity = val;
		}
	},
	mounted() {
		this.id = this.$route.query.id;
		if (this.id) {
			this.getDetail();
		}
		this.getList();
	},
	methods: {
		getList() {
			list().then(({ code, data, message }) => {
				if (code == 200) {
					this.tableData = data;
				} else {
					this.$message.error(message);
				}
			});
		},
		getDetail() {
			detail(this.id).then(({ code, data }) => {
				if (code == 200) {
					this.form = {
						productName: data.productName,
						subTitle: data.subTitle,
						coverImage: data.coverImage,
						sku: data.sku,
						status: data.status,
						languageId: +data.languageId,
						siteId: +data.siteId,
						url: data.url,
						androidUrl: data.androidUrl,
						iosUrl: data.iosUrl,
						continuousPower: data.continuousPower,
						powerBoostMode: data.powerBoostMode,
						surgePower: data.surgePower,
						selfConsumption: data.selfConsumption,
						productCapacity: data.productCapacity,
						totalCapacity: data.totalCapacity,
						depthOfDischarge: data.depthOfDischarge,
						usableCapacity: data.usableCapacity,
						maxBatteries: data.maxBatteries,
						acInputPower: data.acInputPower,
						carChargerInputPower: data.carChargerInputPower,
						efficiency: data.efficiency
					};
				}
			})
		},
		handleChange(val) {
			this.$nextTick(() => {
				if (val) {
					this.$refs.form.clearValidate("coverImage");
				}
			})
		},
		handleSave() {
			this.$refs.form.validate(valid => {
				if (!valid) return;
				const params = {
					...this.form
				}
				if (!this.id) {
					add(params).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("添加成功");
							this.$router.back();
						} else {
							this.$message.error(message);
						}
					})
				} else {
					params.id = this.id;
					edit(params).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("修改成功");
							this.$router.back();
						} else {
							this.$message.error(message);
						}
					})
				}
			})
		}
	}
}
</script>

<style></style>